import React from 'react';
import {
  calculateFlightFarePerPax,
  calculateFlightLegTotal,
  isBELFlight,
} from '../../../utils/flightPricing';

const FlightFareSummary = ({ selectedFlights, totalPassengers, onNext }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format(amount);
  };

  const calculateGrandTotal = () =>
    selectedFlights.reduce(
      (sum, flight) => sum + calculateFlightLegTotal(flight, totalPassengers),
      0
    );

  return (
    <div className="w-80 flex-shrink-0 max-lg:w-full max-lg:order-last">
      <div className="bg-white rounded-lg shadow-sm p-6 sticky top-8 max-lg:static max-lg:border max-lg:border-jet-gray-100">
        <h5 className="text-lg font-bold text-jet-gray-900 mb-4">Fare</h5>

        <div className="space-y-4 mb-6">
          {selectedFlights.map((flight) => {
            const farePerPax = calculateFlightFarePerPax(flight);
            const legTotal = calculateFlightLegTotal(flight, totalPassengers);
            const isBel = isBELFlight(flight);

            return (
              <div key={flight.id} className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm font-bold text-jet-gray-900">
                      {flight.dep_airport_code}
                    </span>
                    <span className="text-sm text-jet-gray-600 mx-4">→</span>
                    <span className="text-sm font-bold text-jet-gray-900">
                      {flight.arr_airport_code}
                    </span>
                  </div>
                  <div className="text-xs text-jet-gray-600 space-y-1">
                    <div>Passenger(s)</div>
                    <div>{isBel ? 'Block Price' : 'Fare/Pax'}</div>
                    <div>Total Fare</div>
                  </div>
                </div>
                <div className="text-right text-xs text-jet-gray-900 space-y-1">
                  <div></div>
                  <div className="font-semibold">{totalPassengers}</div>
                  <div className="font-semibold">{formatCurrency(farePerPax)}</div>
                  <div className="font-semibold">{formatCurrency(legTotal)}</div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="border-t border-jet-gray-200 pt-4 mb-6">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-bold text-jet-gray-900">Total Passenger(s)</span>
            <span className="text-sm font-bold text-jet-gray-900">{totalPassengers}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm font-bold text-jet-gray-900">Grand Total</span>
            <span className="text-sm font-bold text-jet-gray-900">
              {formatCurrency(calculateGrandTotal())}
            </span>
          </div>
        </div>

        <div className="text-center">
          <button
            onClick={onNext}
            className="w-full bg-jet-green-600 hover:bg-jet-green-700 text-white font-medium py-3 px-4 rounded-md transition-colors"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default FlightFareSummary;
